import React, { useMemo, useState } from 'react'
import { Editable, withReact, Slate } from 'slate-react'
import { createEditor } from 'slate'
import { CREATE_NOTE, UPDATE_NOTE, REMOVE_NOTE } from "utils/mutations";
import { useMutation } from "@apollo/react-hooks";

const Tags = (props) => {
    const { tags = [], status, setNoteTags } = props;
    const [tag, setTag] = useState("");
    
    const addTag = () => {
        const regex = new RegExp(/[^a-zA-Z0-9']/g);
        if (!regex.test(tag) && tag.length && !tags.includes(tag)) {
            setNoteTags(prevState => [...prevState, tag]);
            setTag("");
        }
    }

    return (
        <div className="mt-5">
            <div>
                {tags.map((t, idx) => (
                    <span key={idx} className="py-1 px-2 mr-2 bg-gray-600 text-white">
                        {t}
                        <button 
                            disabled={status}
                            className={`ml-2 ${status ? "hidden" : ""}`}
                            onClick={() => setNoteTags(prevState => prevState.filter((t, i) => i !== idx))}
                        >
                            x
                        </button>
                    </span>
                ))}
            </div>

            <div className={`${status ? "hidden" : ""}`}>
                <input 
                    className="border border-gray-400 my-2 focus:outline-none px-2"
                    type="text"
                    placeholder="Enter tags here"
                    value={tag} 
                    onChange={e => setTag(e.target.value)} 
                />
                <button 
                    className="mx-2"
                    disabled={status}
                    onClick={addTag}
                >
                    Add
                </button>
            </div>
        </div>
    );
};

const NoteEditor = (props) => {
    const { note, userId, appendToNotes, updateToNotes, removeFromNotes } = props;
    const { id, body, tags } = note || {};

    const [value, setValue] = useState(body || initialValue);
    const [noteTags, setNoteTags] = useState(tags || []);
    const editor = useMemo(() => withReact(createEditor()), []);
    const [createNote] = useMutation(CREATE_NOTE);
    const [updateNote] = useMutation(UPDATE_NOTE);
    const [removeNote] = useMutation(REMOVE_NOTE);

    const ownerId = (note || {}).agent_id;
    const isOwner = ownerId && ownerId === localStorage.userId;
    const status = !isOwner && !!note;

    const handleSave = () => {
        const text = value.map(p => p.children
            .map(t => t.text).join(" "))
            .join(" ").slice(0, 255).trim();

        if (!text.length) return;
        
        let data;
        if (id) {
            data = {
                id,
                body: JSON.stringify({ text: value }),
                text,
                tags: JSON.stringify({ tags: noteTags })
            };

            updateNote({ variables: data })
                .then(
                    (res) => {
                        const { status, message, payload } = res.data.updateNote;
                        if (status === "OK") {
                            updateToNotes({
                                id,
                                body: value,
                                body_text: text,
                                tags: noteTags
                            });
                        } else {
                            console.log(message);
                        }
                    }
                );
        } else {
            data = {
                user_id: userId,
                body: JSON.stringify({ text: value }),
                text,
                tags: JSON.stringify({ tags: noteTags })
            };
            createNote({ variables: data })
                .then(
                    (res) => {
                        const { status, message, payload } = res.data.createNote;
                        if (status === "OK") {
                            if (payload) appendToNotes(JSON.parse(payload));
                            setValue(initialValue);
                            setNoteTags([]);
                        } else {
                            console.log(message)
                        }
                    }
                );
        }
    };

    const handleDelete = () => {
        if (id) {
            if (window.confirm("delete this note?")) {
                removeNote({ variables: { id } })
                    .then(() => removeFromNotes(id));
            }
        } else {
            setValue(initialValue);
        }
    }

    return (
        <div className="mx-5 bg-white">
            <div className="p-5">
            <div className={`px-2 py-5 ${status ? "" : "border-gray-400 border bg-white"}`}>
                <Slate
                    editor={editor}
                    value={value}
                    onChange={value => setValue(value)}>
                    <Editable
                        readOnly={status}
                        placeholder="Enter notes here..." />
                </Slate>
            </div>

            <Tags tags={noteTags} setNoteTags={setNoteTags} status={status}/>
            <div className={`${ status ? "hidden" : "" }`}>
                <button
                    className="text-green-primary m-5"
                    disabled={status}
                    onClick={handleSave}>
                    Save
                </button>
                <button
                    className="text-green-primary m-5"
                    disabled={status}
                    onClick={handleDelete}
                >
                    {id ? "Delete" : "Clear"}
                </button>
            </div>
            </div>
        </div>
    );
};

const initialValue = [
    {
        children: [
            { text: '' },
        ],
    },
];

export default NoteEditor;